import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '@/pages/Login.vue';
import Wrapper from '@/pages/Wrapper.vue';
import Dashboard from '@/pages/Dashboard.vue';
import StockReport from '@/pages/StockReport.vue';
import Billing from '@/pages/Billing.vue';
import Return from '@/pages/Return.vue';
import Shopkeeper from '@/pages/Shopkeeper.vue';
import Companies from '@/pages/Companies.vue';
import Product from '@/pages/Product.vue';
import Salesman from '@/pages/Salesman.vue';
import SalesmanShops from '@/pages/SalesmanShops.vue';
import InventoryDaily from '@/pages/InventoryDaily.vue';
import BalanceSheetDaily from '@/pages/BalanceSheetDaily.vue';
import BalanceSheetShop from '@/pages/BalanceSheetShop.vue';
import BalanceSheetSalesman from '@/pages/BalanceSheetSalesman.vue';
import addBilling from '@/pages/addBilling.vue';
import addPayment from '@/pages/addPayment.vue';
import addPaymentViaCompany from '@/pages/addPaymentViaCompany.vue';
import addReturn from '@/pages/addReturn.vue';
import transactions from '@/pages/transactions.vue'
import CompanyClaims from '@/pages/CompanyClaims.vue'

const routes: Array<RouteRecordRaw> =[
    {path: '',name: 'Login',component: Login},

    {
      path: '',
      component: Wrapper,
      children: [
        {path: '/dashboard', component: Dashboard},
        {path: '/reports/stock', component: StockReport},
        {path: '/shops', component: Shopkeeper},
        {path: '/companies', component: Companies},
        {
          path: '/companies/products/:company_id',
          component: Product,
          props: true,
        },
        {path: '/salesman', component: Salesman},
        {
          path: '/salesman/shops/:salesman_id',
          component: SalesmanShops,
          props: true,
        },
        {
          path: '/billing',
          component: Billing,
          
        },
        {
          path: '/billing/add',
          component: addBilling,
          
        },
        {
          path: '/billing/edit/:billing_id',
          component: addBilling,
          props: true,
        },
        
        {
          path: '/return',
          component: Return,
          
        },
        {
          path: '/return/add',
          component: addReturn,
          
        },
        {
          path: '/inventory-daily',
          component: InventoryDaily,
          
        },
        {
          path: '/balancesheet/daily',
          component: BalanceSheetDaily,
          
        },
        {
          path: '/balancesheet/shop',
          component: BalanceSheetShop,
          
        },
        {
          path: '/balancesheet/salesman',
          component: BalanceSheetSalesman,
          
        },
        {
          path: '/payment/add',
          component: addPayment,

        },
        {
          path: '/payment/company/add',
          component: addPaymentViaCompany,

        },
        {
          path: '/payment/edit/:payment_id',
          component: addPayment,
          props: true,
        },
        {
          path: '/companies/transactions/:company_id',
          component: transactions,
          props: true,
        },
        {
          path: '/companies/claims/:company_id',
          component: CompanyClaims,
          props: true,
        },
      ]
    }

  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
